module.exports = __webpack_public_path__ + "img/home_industry_text.a31081cc.png";